import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { System } from '../../System';
import * as moment from 'moment';

@Component({
    selector: 'tyl-time-field',
    templateUrl: './tyl-time-field.component.html',
    styleUrls: ['./tyl-time-field.component.css']
})
export class TylTimeFieldComponent implements OnInit {

    // Injected Properties
    @Input() id: string;
    @Input() name: string;
    @Input() label: string;
    @Input() twelveHourFormat = true;
    @Input() change24HoursTo12Hours = false;
    @Input() useValidator = false;
    @Input() width = 'inherit';
    @Input() required = false;
    @Input() disabled = false;
    @Input() showNowButton = false;
    @Input() customHint: string;
    @Output() timeValueChange = new EventEmitter<string>();
    @Output() timeFieldChange = new EventEmitter<ElementRef>();
    @Output() twentyFourHourFormatChange = new EventEmitter<string>();
    @Output() twelveHourFormatFormatChange = new EventEmitter<string>();

    // Local Properties
    twelveHourRegexp = System.twelveHourTimeRegexp;
    twentyFourHourRegexp = System.twentyFourHourTimeRegexp;
    twelveHourTimeMask = System.twelveHourTimeMask;
    twentyFourHourTimeMask = System.twentyFourHourTimeMask;
    _timeValue: string;
    _timeField: ElementRef;

    twentyFourHourTimeRegexp = /^([01]\d|2[0-3]):?([0-5]\d)$/;
    // Class Functions
    constructor() {
    }

    get timeField(): ElementRef {
        return this._timeField;
    }

    @ViewChild('timeField', { read: ElementRef, static: true }) set timeField(value: ElementRef) {
        if (this._timeField != value) {
            this._timeField = value;
            this.timeFieldChange.emit(value);
        }
    }

    get timeValue(): string {
        return this._timeValue;
    }

    @Input() set timeValue(value: string) {
        if (this._timeValue != value) {
            this._timeValue = value;
            this.timeValueChange.emit(value);
            if (this.twelveHourFormat) {
                this.twentyFourHourFormatChange.emit(value);
                this.twentyFourHourFormatChange.emit(System.convert12HourTimeTo24HourTime(value));
            } else {
                this.twelveHourFormatFormatChange.emit(System.convert24HourTimeTo12HourTime(value));
                this.twentyFourHourFormatChange.emit(value);
            }
        }
    }

    // Event Functions
    ngOnInit() {
    }

    onBlur() {
        // PRE: the blur event is called when change24HoursTo12Hours flag is true
        // POST: sets the time in 12 hour format
        if (this.change24HoursTo12Hours == true && this.twelveHourFormat == true && this.timeValue != null && this.timeValue != undefined) {
            let _timeValue = this.timeValue.replace(/_/g, '').replace(/ /g, '').replace(/AM/g, '').replace(/PM/g, '');
            if (_timeValue.length < 4) {
                _timeValue = _timeValue + '00';
            }
            this.timeValue = System.convert24HourTimeTo12HourTime(_timeValue);
        }
    }

    nowClick() {
        // PRE: the now button is clicked
        // POST: sets the time to now
        if (this.twelveHourFormat) {
            this.timeValue = moment(new Date().toString()).format('hh:mm a').toUpperCase();
        } else {
            this.timeValue = moment(new Date().toString()).format('HH:mm').toUpperCase();
        }
    }

    // Methods
}
